export default "__VITE_ASSET__DJ68WrVe__"